<div class="profile-overlay fade-in">
  <div class="profile-header">
    <div class="user-greeting">
      <h5 class="greeting-title">Olá, {{ primeiroNome }}!</h5>
      <div class="user-details">
        <span class="user-orgao">{{ perfil.lotacao }}</span>
        <span class="user-unidade">Unidade SEI {{ perfil.cod_unidade_administrativa_sei }}</span>
        <span class="user-perfil">Perfil {{ perfil.desc_perfil }}</span>
      </div>
    </div>
    <button
      mat-icon-button
      aria-label="Sair"
      color="warn"
      class="logout-btn"
      matTooltip="Sair"
      matTooltipClass="fs-12"
      matTooltipPosition="below"
      (click)="logOut()"
    >
      <mat-icon>logout</mat-icon>
    </button>
  </div>

  <div class="profile-actions">
    <button
      mat-button
      class="action-btn modules-btn"
      (click)="closeOverlay()"
      routerLink="/modulos"
    >
      <mat-icon>apps</mat-icon>
      <span>Seus Módulos</span>
    </button>

    <button
      mat-button
      class="action-btn password-btn"
      (click)="openResetPasswordDialog()"
    >
      <mat-icon>lock</mat-icon>
      <span>Alterar Senha</span>
    </button>
  </div>
</div>
